module.exports = __webpack_public_path__ + "img/ps-10.83521c4e.jpg";